export const CONST_DIRECT_SEARCH_DESTINATIONS = [
  "ChIJAVkDPzdOqEcRcDteW0YgIQQ", // Berlin
  "ChIJuRMYfoNhsUcRoDrWe_I9JgQ", // Hamburg
  "ChIJB1lG8XvJuEcRsHMqSvxgJwQ", // Düsseldorf
  "ChIJn8o2UZ4HbUcRRluiUYrlwv0", // Wien
  "ChIJ2V-Mo_l1nkcRfZixfUq4DAE", // München
  "ChIJ5S-raZElv0cR8HcqSvxgJwQ"   // Köln
];
